import { render } from "./NotificationDropdown.vue?vue&type=template&id=6ce4bb9a"
import script from "./NotificationDropdown.vue?vue&type=script&lang=js"
export * from "./NotificationDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/components/NotificationDropdown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ce4bb9a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ce4bb9a', __exports__)) {
    api.reload('6ce4bb9a', __exports__)
  }
  
  module.hot.accept("./NotificationDropdown.vue?vue&type=template&id=6ce4bb9a", () => {
    api.rerender('6ce4bb9a', render)
  })

}


export default __exports__